import React from 'react';
import { useTranslation } from 'react-i18next';
import TransferHistoryContainer from '@t7x000/apex-web/lib/components/Settings/TransferHistory/index.js';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './UserContactsPage.css';

const userContactsPageClasses = getBEMClasses('user-contacts-page');

const UserContactsPage = () => {
  const { t } = useTranslation();

  return (
    <div className={userContactsPageClasses()}>
      <div className={userContactsPageClasses('block-with-text')}>
        <div className={userContactsPageClasses('header-text')}>{t('Trading with Other On-platform Participants')}</div>
        <div className={userContactsPageClasses('text')}>
          {t(
            'You can freely transfer currency with other participants on the exchange. Simply provide the email address for your contact during the Send or Receive process. If the email address is registered on the exchange, then the user will receive the transfer. If the email address is not registered, the user will get an invitation to join the exchange.',
          )}
        </div>
      </div>
      <div className={userContactsPageClasses('transfer')}>
        <div className={userContactsPageClasses('transfer-header')}>{t('Transfer History')}</div>
        <div className={userContactsPageClasses('transfer-items')}>
          <TransferHistoryContainer />
        </div>
      </div>
    </div>
  );
};

export default UserContactsPage;
